<template lang="pug">
  #home
    header
      Cover
    .container-md.mt-5
      .row
        #menu.col-12.col-md-3.mb-3
           Sidenav
        main.col-12.col-md-9
          Intro
          Section1
          Section2
          Section3
          Section4
          hr
          Footnotes
    Footer.mt-5
</template>

<script>
import Cover from "@/components/Cover.vue";
import Intro from "@/components/Intro.vue";
import Section1 from "@/components/Section1.vue";
import Section2 from "@/components/Section2.vue";
import Section3 from "@/components/Section3.vue";
import Section4 from "@/components/Section4.vue";
import Footnotes from "@/components/Footnotes.vue";
import Sidenav from "@/components/Sidenav.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "home",
  components: {
    Cover,
    Intro,
    Section1,
    Section2,
    Section3,
    Section4,
    Footnotes,
    Sidenav,
    Footer
  }
};
</script>

<style lang="scss" scoped>
#home {
  position: relative;
  hr {
    border: solid 1px #2f2f2f;
  }
}
#menu {
  position: sticky;
  position: -webkit-sticky; /* Safari */
  top: 0px;
  z-index: 12;
  width: 100%;
}
</style>
